import "./photo-uploader.styl"
import photoUploaderTemplateFn from "./photo-uploader.pug"
import { uploadAttachment } from "@/lib/utils/attachment-url-resolver"
import ko from "knockout"

export class PhotoUploader
   constructor: (params) ->
      assertArgs(arguments, Object)
      assertOfType(params.photo, Function)
      assertOfType(params.callback, optional(Function))
      assertOfType(params.disableEdit, optional([Boolean, Function]))

      @logoUrl = "#{window.config.LC_DOMAIN}/images/lc-logo-gray.png"
      @photo = params.photo
      @callback = if params.callback? then params.callback else () ->
      @showLoading = ko.observable(false)
      if params.disableEdit?
         if params.disableEdit instanceof Function
            @disableEdit = params.disableEdit
         else
            @disableEdit = ko.observable(params.disableEdit)
      else
         @disableEdit = ko.observable(false)

      # Control properties.
      @showFormatAlert = ko.observable(false)

      @disposablePhotoBlock = false

      @newFile = ko.observable()
      @newFile.subscribe (newVal) =>
         return unless newVal?
         try
            @showLoading(true)
            @showFormatAlert(false)
            @disposablePhotoBlock = true
            
            # Get file info
            file = newVal
            { name, size, type } = file
            
            # Check file type
            validTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'image/bmp']
            if not validTypes.includes(type)
               @showFormatAlert(true)
               @showLoading(false)
               @photo(null)
               return
            
            # Upload to S3 and get signed URL
            result = await uploadAttachment(file)
            
            # Set display URL and notify parent with attachment ID
            @photo(result.signedUrl)
            @showLoading(false)
            @callback(result.attachmentId)
         catch err
            @showLoading(false)
            @showFormatAlert(true)
            @photo(null)
            console.error "Photo upload error:", err

   clearPhoto: ->
      @photo(null)
      @callback(null)


photoUploaderTemplate = photoUploaderTemplateFn()

ko.components.register("photo-uploader",
   viewModel: PhotoUploader,
   template: photoUploaderTemplate,
)
